var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 5.96602C14.9499 5.95769 14.8916 5.95769 14.8416 5.96602C13.6916 5.92435 12.7749 4.98268 12.7749 3.81602C12.7749 2.62435 13.7332 1.66602 14.9249 1.66602C16.1166 1.66602 17.0749 2.63268 17.0749 3.81602C17.0666 4.98268 16.1499 5.92435 14.9999 5.96602Z",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1417 12.0328C15.2834 12.2245 16.5417 12.0245 17.425 11.4328C18.6 10.6495 18.6 9.36615 17.425 8.58282C16.5334 7.99115 15.2584 7.79115 14.1167 7.99115",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97539 5.96602C5.02539 5.95769 5.08372 5.95769 5.13372 5.96602C6.28372 5.92435 7.20039 4.98268 7.20039 3.81602C7.20039 2.62435 6.24206 1.66602 5.05039 1.66602C3.85873 1.66602 2.90039 2.63268 2.90039 3.81602C2.90872 4.98268 3.82539 5.92435 4.97539 5.96602Z",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83353 12.0328C4.69186 12.2245 3.43353 12.0245 2.5502 11.4328C1.3752 10.6495 1.3752 9.36615 2.5502 8.58282C3.44186 7.99115 4.71686 7.79115 5.85853 7.99115",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9999 12.1926C9.9499 12.1842 9.89157 12.1842 9.84157 12.1926C8.69157 12.1509 7.7749 11.2092 7.7749 10.0426C7.7749 8.85091 8.73323 7.89258 9.9249 7.89258C11.1166 7.89258 12.0749 8.85925 12.0749 10.0426C12.0666 11.2092 11.1499 12.1592 9.9999 12.1926Z",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4251 14.8168C11.1001 13.9335 8.90843 13.9335 7.5751 14.8168C6.4001 15.6001 6.4001 16.8835 7.5751 17.6668C8.90843 18.5585 11.0918 18.5585 12.4251 17.6668",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeesIcon);
export default __webpack_public_path__ + "static/media/employeesIcon.a63968bb6e002e0bba0a6d182ffb19c5.svg";
export { ForwardRef as ReactComponent };